module.exports = __webpack_public_path__ + "static/media/US-Land-Shop-Hero-Background.4dbc02c4.jpg";